import { useContext, useEffect, useReducer } from "react";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

// O socket manda o ticket com a etiqueta de qualquer usuário; aqui ela é conferida contra o GET /tags.

let dono = null;
let ids = null;
let carregando = null;
const conferidos = new Set();
const ouvintes = new Set();

const recarregar = () => {
	if (!carregando) {
		const pedidoDe = dono;
		carregando = api.get("/tags")
			.then(({ data }) => {
				if (pedidoDe === dono) ids = new Set((data || []).map(tag => Number(tag.id)));
			})
			.catch(() => {
				if (pedidoDe === dono && ids === null) ids = new Set();
			})
			.finally(() => {
				carregando = null;
				ouvintes.forEach(avisar => avisar());
			});
	}
};

const useTagVisivel = (tagId) => {
	const { user } = useContext(AuthContext);
	const [, atualizar] = useReducer(x => x + 1, 0);
	const id = tagId === null || tagId === undefined ? null : Number(tagId);
	const userId = user?.id;

	if (userId !== dono) {
		dono = userId;
		ids = null;
		conferidos.clear();
	}

	useEffect(() => {
		ouvintes.add(atualizar);
		return () => ouvintes.delete(atualizar);
	}, []);

	useEffect(() => {
		if (id === null || !dono) return;
		if (ids === null) {
			recarregar();
		} else if (!ids.has(id) && !conferidos.has(id)) {
			conferidos.add(id);
			recarregar();
		}
	}, [id, userId]);

	return id !== null && ids !== null && ids.has(id);
};

export default useTagVisivel;
